import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Drawer, Divider, Spin } from "antd";
import useStore from "../../../../../../store";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { finance_source } from "../../../../../../utils/GlobalFunction";
import moment from "moment";
import InputComponent from "../../../../../../component/InputComponent";
import debounce from "lodash/debounce";
import { vsmFinanceLedger, vsmNotify } from "../../../../../../config/messages";

const EDitFinanceComponent = observer((props) => {

	const [form] = Form.useForm();
	const {
		ManageZFormsStore,
		ManageZFormsStore: { finance_detail },
		AUTH
	} = useStore();
	const { openConfirmFinanceModal } = props;
	const [saving, setSaving] = useState();
	const [disabled, setDisabled] = useState(true);
	const [fieldDisable, setFieldDisable] = useState(true);
	const [showSource, setShowSource] = useState(false);
	const [showDSA, setShowDSA] = useState(false);
	const [showDSAText, setShowDSAText] = useState(false);
	const [fetchSource, setFetchSource] = useState(true);
	const [fetchBank, setFetchBank] = useState(true);
	const [fetchDSA, setFetchDSA] = useState(true);
	const [requiredBank, setRequiredBank] = useState(false);

	// Make function call to delete existing record
	const handleSubmit = (data) => {
		data.booking_id = ManageZFormsStore.viewValues.id
		if (form.getFieldValue("need_finance") === 0 || form.getFieldValue("ls_id") === finance_source["SELF"]) {
			resetStates()
			openConfirmFinanceModal(data);
		}
		else {
			setSaving(true);
			ManageZFormsStore.applyFinance(data)
				.then((data) => {
					close();
					vsmNotify.success({
						message: data.STATUS.NOTIFICATION[0],
					});
				})
				.catch((e) => {
					if (e.errors) {
						form.setFields(e.errors);
					}
				})
				.finally(() => {
					setSaving(false);
				});
		}

	};

	const handleLoanSource = debounce(() => {
		form.setFieldsValue({ have_dsa: 0 })
		form.setFieldsValue({
			dsa_id: "",
			pan_card: "",
			dsa_comm: 0,
		})
		const loan_source = form.getFieldValue("ls_id")
		if (ManageZFormsStore.finance_detail.booking.booking_ledger.po_id) {
			const package_finance_type = ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer.package_definition.fin_type_id
			if (package_finance_type && loan_source !== package_finance_type) {
				form.setFieldsValue({ "ls_id": null })
				vsmNotify.error({
					message: "Invalid Loan Source reference"
				});
			}
			else {
				if (loan_source === 30) {
					setShowDSA(true)
				}
				else {
					setShowDSA(false)
				}
				if ((loan_source === 10 || loan_source === 20)) {
					setShowDSAText(true)
				}
			}
		}
		else {
			if (loan_source === 30) {
				setShowDSA(true)
			}
			else {
				setShowDSA(false)
			}
			if ((loan_source === 10 || loan_source === 20)) {
				setShowDSAText(true)
			}
			else {
				setShowDSAText(false)
				form.setFieldsValue({ have_dsa: null })
			}
		}
		if(loan_source !== 10){
			setRequiredBank(true);
		}
		else{
			setRequiredBank(false);
		}
	}, 500)

	const handleChange = debounce(() => {

		form
			.validateFields()
			.then((d) => {
				setDisabled(false);
			})
			.catch((d) => {
				setDisabled(true);
			});
	}, 500);

	useEffect(() => {
		if (props.visible && ManageZFormsStore.viewValues) {
			ManageZFormsStore.financeDetail(ManageZFormsStore.viewValues.id)
		}
	}, [form, props, ManageZFormsStore])

	useEffect(() => {
		if (finance_detail && props.visible) {
			ManageZFormsStore.dropdown_soruce_list = [finance_detail.finance_offer.loan_source]
			ManageZFormsStore.dropdown_bank_list = [finance_detail.finance_offer.bank]
			ManageZFormsStore.dropdown_dsa_list = [finance_detail.finance_offer.dsa]
			form.setFieldsValue({
				need_finance: finance_detail.finance_offer.need_finance,
				ls_id: finance_detail.finance_offer.ls_id ? finance_detail.finance_offer.loan_source.id : null,
				bank_id: finance_detail.finance_offer.bank_id ? finance_detail.finance_offer.bank.id : null,
				dsa_id: finance_detail.finance_offer.dsa_id ? finance_detail.finance_offer.dsa.id : null,
				pan_card: finance_detail.finance_offer.dsa_id ? finance_detail.finance_offer.dsa.pan_card : null,
				dsa_comm: finance_detail.finance_offer.dsa_comm,
				remarks_sc: finance_detail.finance_offer.remarks_sc,
			})
			setShowSource(false);
			if (finance_detail.finance_offer.need_finance === 1) {
				setShowSource(true);
				setShowDSA(true);
			}
			if(finance_detail.finance_offer.ls_id !== 10 && finance_detail.finance_offer.need_finance === 1){				
				setRequiredBank(true);
			}
			else if (finance_detail.finance_offer.need_finance === 0) {
				setShowDSAText(true)
			}


			setFieldDisable(true);

			if ((AUTH?.user?.id === ManageZFormsStore.viewValues.sales_consultant.id) && ([0, 10, 100].includes(ManageZFormsStore.viewValues.finance_status) || (ManageZFormsStore.viewValues.finance_status === null)) && ManageZFormsStore.viewValues.status === 20) {
				setFieldDisable(false);
			}

			if (finance_detail.finance_offer.ls_id === 30) {
				setShowDSA(true)
			}
			else {
				setShowDSA(false)
			}
			if ((finance_detail.finance_offer.ls_id === 20 || finance_detail.finance_offer.ls_id === 10)) {
				setShowDSAText(true)
			}
			if ((finance_detail.finance_offer.ls_id === 20 || finance_detail.finance_offer.ls_id === 10) && finance_detail.finance_offer.dsa) {
				form.setFieldsValue({ have_dsa: 1 })
				setShowDSA(true)
			}
			else if ((finance_detail.finance_offer.need_finance === 0 && ManageZFormsStore.finance_detail.finance_offer.dsa)) {
				form.setFieldsValue({ have_dsa: 1 })
				setShowDSA(true)
			}
			else (
				form.setFieldsValue({ have_dsa: 0 })
			)

		}
	}, [form, ManageZFormsStore, AUTH, props.visible, finance_detail])
	const handleNeedFinance = () => {
		const need_finance = form.getFieldValue("need_finance")
		form.setFieldsValue({ have_dsa: 0 })
		if (need_finance === 1) {
			setRequiredBank(true);
		}
		if (ManageZFormsStore.finance_detail.booking.booking_ledger.po_id) {
			const need_finance_flag = ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer.package_definition.fin_flag
			if (need_finance === 1 && [1, 100].includes(need_finance_flag)) {
				form.setFieldsValue({ need_finance: 1 })
				setShowSource(true);
				// setShowDSA(true);
				setShowDSAText(false)
				setShowDSA(false);
			}
			else if (need_finance === 0 && [0, 100].includes(need_finance_flag)) {
				form.setFieldsValue({ need_finance: 0 })
				setShowSource(false);
				setShowDSA(false);
				setShowDSAText(true)
			}
			else {
				form.setFieldsValue({ need_finance: null })

			}
		}
		else {
			const loan_source = form.getFieldValue("ls_id")
			if (need_finance === 1) {
				setShowSource(true);
				let ls_id = form.getFieldValue("ls_id");
				const have_dsa = form.getFieldValue("have_dsa")
				if (ls_id === 30) {
					setShowDSA(true);
				}
				if (have_dsa === 1 && (ls_id === 10 || ls_id === 20)) {
					setShowDSA(true);
				}
				if ((loan_source === 10 || loan_source === 20)) {
					setShowDSAText(true)
				}
				else {
					setShowDSAText(false)
				}
			}
			else {
				setShowSource(false);
				setShowDSA(false);
				setShowDSAText(true)
			}
		}
	}
	const handleHaveDSA = () => {
		const have_dsa = form.getFieldValue("have_dsa")
		if (have_dsa === 1) {
			setShowDSA(true);
		}
		else {

			setShowDSA(false);
		}
	}

	const handleBankChange = () => {
		const bank_type = form.getFieldValue("bank_id")
		if (ManageZFormsStore.finance_detail.booking.booking_ledger.po_id) {
			const package_bank_type = ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer.package_definition.bank_id

			if (package_bank_type && bank_type !== package_bank_type) {
				form.setFieldsValue({ "bank_id": null })
				vsmNotify.error({
					message: "Invalid Bank reference"
				});
			}
		}
	}

	const handleDSAChange = () => {
		const dsa_id = form.getFieldValue("dsa_id")
		const pan_card = ManageZFormsStore.dropdown_dsa_list.filter((item) => item.id === dsa_id).map((item) => item.pan_card)
		form.setFieldsValue({ "pan_card": pan_card });
	}


	// reset form and close add form
	const close = () => {
		props.close();
		form.resetFields();
		setSaving();
		setDisabled(true);
		setFieldDisable(true);
		setShowSource(false);
		setShowDSAText(false)
		setShowDSA(false);
		setFetchSource(true);
		setFetchBank(true);
		setFetchDSA(true);
		setRequiredBank(false);
		ManageZFormsStore.finance_detail = null;
		ManageZFormsStore.dropdown_bank_list = null;
		ManageZFormsStore.dropdown_soruce_list = null;
		ManageZFormsStore.dropdown_dsa_list = null
	};

	const resetStates = () => {
		setSaving();
		setDisabled(true);
		setFieldDisable(true);
		setShowSource(false);
		setShowDSAText(false)
		setShowDSA(false);
		setFetchSource(true);
		setFetchBank(true);
		setFetchDSA(true);
		setRequiredBank(false);
		ManageZFormsStore.dropdown_bank_list = null;
		ManageZFormsStore.dropdown_soruce_list = null;
		ManageZFormsStore.dropdown_dsa_list = null
	}

	return ManageZFormsStore.viewValues && ManageZFormsStore.finance_detail ? (
		<Drawer
			className="addModal"
			title={`Finance(${ManageZFormsStore.viewValues.booking_ledger?.id})`}
			width="70%"
			destroyOnClose
			visible={props.visible}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			onClose={close}
			footer={[
				<Button
					key="1"
					className="cancelBtn mr-15"
					htmlType="button"
					type="primary"
					onClick={close}
				>
					Close
				</Button>,
				<Button
					key="2"
					form="editFianceForm"
					loading={saving}
					disabled={disabled}
					htmlType="submit"
					type="primary"
				>
					Save
				</Button>
			]}
		>
			<Form
				form={form}
				id="editFianceForm"
				onFinish={handleSubmit}
				labelCol={{ span: 24 }}
				onChange={handleChange}
			>
				<Row gutter={30} className="zform_block_wrapper">
					<Col xs={{ span: 24 }} sm={{ span: 8 }} >
						<div className="zform_block blue_block">
							<p>CO NO - {ManageZFormsStore.viewValues?.co_no ? ManageZFormsStore.viewValues.co_no : 'N/A'}</p>
							{/* <span title={ManageZFormsStore.viewValues.co_no}>
								{ManageZFormsStore.viewValues.co_no}
							</span> */}
							<span className="small">
								{ManageZFormsStore.viewValues?.sales_consultant?.name}
							</span>
							<span className="small">{moment(ManageZFormsStore.viewValues?.created).format("DD/MM/YYYY")}</span>
						</div>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 8 }} >
						<div className="zform_block green_block" >
							<p>Customer</p>
							<span title={ManageZFormsStore.viewValues.booking_customer.title.name + " " + (ManageZFormsStore.viewValues.booking_customer.changed_name ? ManageZFormsStore.viewValues.booking_customer.changed_name : ManageZFormsStore.viewValues.booking_customer.full_name)}>
								{ManageZFormsStore.viewValues.booking_customer.title.name + " " + (ManageZFormsStore.viewValues.booking_customer.changed_name ? ManageZFormsStore.viewValues.booking_customer.changed_name : ManageZFormsStore.viewValues.booking_customer.full_name)}
							</span>
							<span className="small">{ManageZFormsStore.viewValues.location.name}</span>
						</div>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 8 }} >
						<div className="zform_block orange_block" >
							<p>Variant</p>
							<span title={ManageZFormsStore.viewValues.booking_model.variant ? ManageZFormsStore.viewValues.booking_model.variant.name : "N/A"}>
								{ManageZFormsStore.viewValues.booking_model.variant ? ManageZFormsStore.viewValues.booking_model.variant.name : "N/A"}
							</span>
							<span className="small">{ManageZFormsStore.viewValues.booking_model.color ? ManageZFormsStore.viewValues.booking_model.color.name : "N/A"}</span>
						</div>
					</Col>
				</Row>
				<Row>
					<Col xs={{ span: 24 }}>
						<InputComponent
							type="radio_button"
							required
							rules={vsmFinanceLedger.validation.need_finance}
							disabled={fieldDisable}
							label="Need Finance?"
							name="need_finance"
							onChange={() => { handleNeedFinance(); handleChange(); }}
							// rules={vsmCorporateBenefit.validation.is_corporate}
							options={{
								values: [
									{ id: 1, name: "Yes" },
									{ id: 0, name: "No" },
								],
								value_key: "id",
								text_key: "name",
							}}
						/>
					</Col>
				</Row>



				<Row gutter={30}>
					{showSource && <><Col xs={{ span: 24 }}>
						<Divider />
						<h1 className="formTitle">Loan Source</h1>
					</Col>
						<Col xs={{ span: 24 }} sm={{ span: 12 }} lg={{ span: 8 }}>
							<InputComponent
								type="select"
								allowClear
								required
								autoComplete="chrome-off"
								disabled={fieldDisable}
								label="Loan Source"
								name="ls_id"
								placeholder="Loan Source"
								rules={vsmFinanceLedger.validation.ls_id}
								onChange={() => { handleLoanSource(); handleChange(); }}
								onFocus={() =>
									fetchSource && ManageZFormsStore.getLoanSourceList().then(() => setFetchSource(false))
								}
								notFoundContent={
									fetchSource ? <Spin size="small" /> : "No Record Found."
								}
								options={{
									values: ManageZFormsStore.dropdown_soruce_list,
									value_key: "id",
									text_key: "name",
								}}
							/>
						</Col>
						<Col xs={{ span: 24 }} sm={{ span: 12 }} lg={{ span: 8 }}>
							<InputComponent
								type="select"
								allowClear
								autoComplete="chrome-off"
								disabled={fieldDisable}
								required={requiredBank}
								label="Bank"
								name="bank_id"
								placeholder="Bank"
								rules={vsmFinanceLedger.validation.bank_id}
								onChange={() => { handleBankChange(); handleChange(); }}
								onFocus={() =>
									fetchBank && ManageZFormsStore.getBanks().then(() => setFetchBank(false))
								}
								notFoundContent={
									fetchBank ? <Spin size="small" /> : "No Record Found."
								}
								options={{
									values: ManageZFormsStore.dropdown_bank_list,
									value_key: "id",
									text_key: "name",
								}}
							/>
						</Col></>
					}
					{showDSAText &&
						<Col xs={{ span: 8 }}>
							<InputComponent
								type="radio_button"
								required
								rules={vsmFinanceLedger.validation.need_finance}
								disabled={fieldDisable}
								label="Have DSA?"
								name="have_dsa"
								onChange={() => { handleHaveDSA(); handleChange(); }}
								// rules={vsmCorporateBenefit.validation.is_corporate}
								options={{
									values: [
										{ id: 1, name: "Yes" },
										{ id: 0, name: "No" },
									],
									value_key: "id",
									text_key: "name",
								}}
							/>
						</Col>}
				</Row>
				{showDSA &&
					<Row gutter={30}>
						<Col xs={{ span: 24 }}>
							<Divider />
						</Col>
						<Col xs={{ span: 24 }} sm={{ span: 12 }} lg={{ span: 8 }}>
							<InputComponent
								type="select"
								allowClear
								autoComplete="chrome-off"
								label="DSA"
								name="dsa_id"
								required={form.getFieldValue("ls_id") === 30 || form.getFieldValue("have_dsa") === 1}
								placeholder="DSA"
								rules={form.getFieldValue("ls_id") === 30 || form.getFieldValue("have_dsa") === 1 ? vsmFinanceLedger.validation.dsa_id : [{ required: false, message: "" }]}
								onChange={() => { handleDSAChange(); handleChange(); }}
								onFocus={() =>
									fetchDSA && ManageZFormsStore.getDSAList().then(() => setFetchDSA(false))
								}
								notFoundContent={
									fetchDSA ? <Spin size="small" /> : "No Record Found."
								}
								options={{
									values: ManageZFormsStore.dropdown_dsa_list,
									value_key: "id",
									text_key: "name",
								}}
							/>
						</Col>
						<Col xs={{ span: 24 }} sm={{ span: 12 }} lg={{ span: 8 }}>
							<InputComponent
								type="text"
								disabled={true}
								label="PAN Card"
								placeholder="PAN Card"
								name="pan_card"
							/>
						</Col>
						<Col xs={{ span: 24 }} sm={{ span: 12 }} lg={{ span: 8 }}>
							<InputComponent
								type="text"
								label="Commission Amount"
								required={form.getFieldValue("ls_id") === 30 || form.getFieldValue("have_dsa") === 1}
								placeholder="Commission Amount"
								name="dsa_comm"
								rules={form.getFieldValue("ls_id") === 30 || form.getFieldValue("have_dsa") === 1 ? vsmFinanceLedger.validation.dsa_comm : [{ required: false, message: "" }]}
							/>
						</Col>
					</Row>
				}
				<Row gutter={30}>
					<Col xs={{ span: 24 }}>
						<Divider />
					</Col>
					<Col xs={{ span: 24 }}>
						<InputComponent
							type="textarea"
							required={form.getFieldValue("need_finance") === 0 ? true : false}
							rules={form.getFieldValue("need_finance") === 0 ? vsmFinanceLedger.validation.remarks_sc_with_required : vsmFinanceLedger.validation.remarks_sc}
							label="Remarks by Sales Consultant"
							placeholder="Remarks"
							name="remarks_sc"
						/>
					</Col>
				</Row>
				{(ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer !== null && ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_flag !== 100) &&
					<Row gutter={30}>
						<Col xs={{ span: 24 }}>
							{
								ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_flag === 0 &&
								<p className="blueText">{ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package.name} is applied on Z-Forms without Finance</p>
							}
							{
								(ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_flag === 1 && ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_type === null && ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.bank === null) &&
								<p className="blueText">{ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package.name}  is applied on Z-Forms with Finance</p>
							}
							{
								(ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_flag === 1 && ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_type !== null && ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.bank === null) &&
								<p className="blueText">{ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package.name}   is applied on Z-Forms with Finance source {ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_type.name}</p>
							}
							{
								(ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_flag === 1 && ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_type === null && ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.bank !== null) &&
								<p className="blueText">{ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package.name}   is applied on Z-Forms with Finance through {ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.bank.name}</p>
							}
							{
								(ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_flag === 1 && ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_type !== null && ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.bank !== null) &&
								<p className="blueText">{ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package.name}    is applied on Z-Forms with Finance source {ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.fin_type.name} through {ManageZFormsStore.finance_detail.booking.booking_ledger.package_offer?.package_definition.bank.name}</p>
							}
						</Col>
					</Row>
				}
			</Form>
		</Drawer>
	) : null;
});

export default EDitFinanceComponent;
